

<template>
  <div class="index_app" v-cloak>
      <!-- 头部 -->
      <Header />
      <!-- 轮播图 -->
      <div class="carousel" @click="onCarouselClick">
        <el-carousel :interval="5000" ref="slideCarousel"
          @touchstart.native="carouselTouchStart" @touchend.native="carouselTouchEnd">
          <el-carousel-item v-for="(item, index) in carouselList" :key="index">
            <div class="cs_contain" :style='{ backgroundImage : "url(" + item.url + ")" }'>
<!--              <div class="content-width">-->
<!--                <div :class="['cs_word', index === 0 || index === 1 ? 'cs_word3' : '']">-->
<!--                  <div v-cloak v-if="item.title1" class="title1">{{item.title1}}</div>-->
<!--                  <div v-cloak class="title2">{{item.title2}}</div>-->
<!--                  <div v-cloak class="remark"><span v-for="(item1,index1) in item.remark"-->
<!--                      :class="index1 > 0?'cs_remark':''">{{item1}}<span-->
<!--                        v-if="index1 < item.remark.length - 1">、</span></span></div>-->
<!--                </div>-->
<!--&lt;!&ndash;                <el-button type="primary" round :class="index === 2?'use_btn cs_btn':'use_btn'" @click="useClick">申请试用&ndash;&gt;-->
<!--&lt;!&ndash;                </el-button>&ndash;&gt;-->
<!--              </div>-->
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 穗盈生鲜供应链系统 -->
      <div class="system-intro">
        <div class="content">
          <div class="sys-title">穗盈生鲜供应链系统</div>
          <div class="sys-desc">穗盈生鲜供应链系统作为广州市智慧农业服务股份有限公司自主研发的核心产品，通过数字化技术优化食材供应链的每一个环节，为生鲜配送企业提供从订单管理、采购、库存管理到分拣配送、财务管理、经营分析的全流程覆盖，服务于以下客户群体</div>
          <ul class="sys-icons">
            <li>
              <img src="@/assets/appimg/index/pic/index-sys1.svg" />
              <span>中小型配送商</span>
            </li>
            <li>
              <img src="@/assets/appimg/index/pic/index-sys2.svg" />
              <span>大型生鲜配送供应链企业</span>
            </li>
            <li>
              <img src="@/assets/appimg/index/pic/index-sys3.svg" />
              <span>国有生鲜配送供应链企业</span>
            </li>
            <li>
              <img src="@/assets/appimg/index/pic/index-sys4.svg" />
              <span>集采供应商</span>
            </li>
          </ul>
          <img class="sys-pic" src="@/assets/appimg/index/pic/index-sys.jpg" />
        </div>
      </div>
      <!-- 直击行业痛点 -->
      <div class="pain-point">
        <div class="content">
          <div class="pp-title">直击行业痛点</div>
          <div class="pp-desc">传统人工管理模式下，食材配送过程中容易出现信息不透明、流转效率低下的问题，亟需通过全流程数字化转型突破困境</div>
          <ul class="pp-list">
            <li>
              <img src="@/assets/appimg/index/pic/index-t1.jpg" />
              <div class="pp-name">单据易丢失</div>
              <div class="pp-item">来回打印浪费纸张</div>
              <div class="pp-item">对单找货难查找</div>
            </li>
            <li>
              <img src="@/assets/appimg/index/pic/index-t2.jpg" />
              <div class="pp-name">配送效率低</div>
              <div class="pp-item">分拣现场混乱</div>
              <div class="pp-item">送达现场才发现串货</div>
            </li>
            <li>
              <img src="@/assets/appimg/index/pic/index-t3.jpg" />
              <div class="pp-name">收款难度大</div>
              <div class="pp-item">对账验收耗时耗力</div>
              <div class="pp-item">和供应商来回扯皮</div>
            </li>
            <li>
              <img src="@/assets/appimg/index/pic/index-t4.jpg" />
              <div class="pp-name">数据难监管</div>
              <div class="pp-item">系统数据同步速度慢</div>
              <div class="pp-item">数据准确性难保证</div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 痛点解法 -->
      <div class="pain-solution">
        <div class="ps-title">痛点解法</div>
        <div class="ps-desc">穗盈生鲜SCM系统提供食材配送全流程数字化解决方案，帮助企业实现从内部管理到外部协同的端到端数字化升级</div>
        <div class="ps-pics">
          <img src="@/assets/appimg/index/pic/jf1.png" />
          <img src="@/assets/appimg/index/pic/jf2.png" />
        </div>
      </div>
      <!-- 食材配送全链数字化 -->
      <div class="full-chain">
        <div class="content">
          <div class="fc-title">食材配送全链数字化</div>
          <div class="fc-desc">集成订单、下单、采购、分拣、食安、财务等核心管理功能，实现从客户需求到供应商协作的无缝对接</div>
        </div>
      </div>

      <!-- 伙伴 -->
      <div class="partner">
        <div class="content content-title">
          <div class="title">合作伙伴</div>
          <div class="remark">打破传统食材配送信息壁垒，降低流转成本，为合作企业构建高效、透明的业务闭环</div>
          <img class="partner-bg" src="@/assets/appimg/index/pic/par.png" />
        </div>
      </div>

      <!-- 客服 / 置顶 -->
      <ReturnTop />
      <!-- 首页申请 -->
      <ApplyIndex />
      <!-- 地址电话官网 -->
      <Contact />
      <!-- 申请 -->
      <Apply ref="applyRef" />
      <!-- 尾部 -->
      <Footer />
      <!-- 咨询弹框 -->
<!--      <CustCare />-->
      <!-- 底部栏 -->
      <FooterBottom />
    </div>
</template>
<script>
    import axios from 'axios'
    import Header from '@/views/app/components/header'
    import CustCare from '@/views/app/components/custCare'
    import ReturnTop from '@/views/app/components/returnTop'
    import FooterBottom from '@/views/app/components/footerBottom'
    import ApplyIndex from '@/views/app/components/applyIndex'
    import Apply from '@/views/app/components/apply'
    import Footer from '@/views/app/components/footer'
    import Contact from '@/views/app/components/contact'
    import { formatDate } from '@/utils/dateFormat'
    import scrollToTop from '@/mixins/scrollToTop'
    export default {
      name: "IndexApp",
      mixins: [scrollToTop],
      components: { Header, CustCare, ReturnTop, Apply, ApplyIndex, Footer, FooterBottom, Contact },
      data () {
        return {
          baseUrl: this.$baseUrl,
          // 首页轮播图
          carouselList: [
            {
              // title1: '全流程一体化',
              // title2: '穗盈生鲜供应链系统',
              // remark: '效率高、简单易用、降低损耗及成本',
              url: require('@/assets/appimg/index/pic/c1.jpg')
            },
            {
              // title1: '为食材供应链提供',
              // title2: '整体数字化可控解决方案',
              // remark: '效率高、简单易用、降低损耗及成本',
              url: require('@/assets/appimg/index/pic/c2.jpg')
            },
            // {
            //   title2: '企业升级转型信息化',
            //   remark: '效率高、简单易用、降低损耗及成本',
            //   url: require('@/assets/appimg/index/pic/cs3.jpg')
            // }
          ],
          //首页资讯列表-拼接
          indexInfoList: [],
          // 公告新闻消息 tab状态
          activeNameInfo: 'first',
          carouselTouchX: 0,
          carouselTouchY: 0,
          carouselSwiped: false
        }
      },
      // created () {
      //   this.getIndexNewsList()
      // },
      created() {
        // this.$router.replace('/refresh')
        this.getIndexNewsList()
      },
      mounted () {
        this.$nextTick(() => {
          if (this.$refs.navTabs){
            this.$refs.navTabs.$refs.nav.$nextTick(() => {
              // 此时tab的nav才渲染dom 否则拿不到el-tabs__item
              let target = document.getElementsByClassName("el-tabs__item");
              let that = this;
              for (let i = 0; i < target.length; i++) {
                target[i].addEventListener("mouseover", () => {
                  that.$refs.navTabs.handleTabClick(1, String(i));
                });
              }
            });
          }
        });
      },
      methods: {
        // 试用
        useClick () {
          this.$refs.applyRef.useClick();
        },
        onCarouselClick () {
          if (this.carouselSwiped) {
            this.carouselSwiped = false
            return
          }
          this.useClick()
        },
        carouselTouchStart (e) {
          this.carouselTouchX = e.changedTouches[0].clientX
          this.carouselTouchY = e.changedTouches[0].clientY
          this.carouselSwiped = false
        },
        carouselTouchEnd (e) {
          const deltaX = this.carouselTouchX - e.changedTouches[0].clientX
          const deltaY = this.carouselTouchY - e.changedTouches[0].clientY
          if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
            this.carouselSwiped = true
            deltaX > 0 ? this.$refs.slideCarousel.next() : this.$refs.slideCarousel.prev()
          }
        },
        // 跳转查看全部
        showMore(type){
          this.$router.push({name:'InstituteAllApp',query:{type:type}});
        },
        // 新闻列表
        getIndexNewsList () {
          let that = this
          let _data = {
            type: 2,
            pageNum: 1,
            pageSize: 6,
            systemType: 1,
          }
          const url = that.baseUrl + "/message/news/list"
          axios.get(url, { params: _data }).then(res=>{
            const list = res.data.newsMap
            that.indexInfoList = list.rows.map( (e) => {
              e.publishTime = formatDate(e.publishTime)
              return e
            })
          })
        },
        // 新闻公告详情跳转
        getInfo (id) {
          this.$router.push({name:'InstituteInfoApp',query:{id:id}});
        },
        // 获取月份
        substrMonth (val) {
          if (val) {
            return val.substring(8, 10)
          }
        },
        // 获取年月
        substrYearMonth (val) {
          if (val) {
            return val.substring(0, 7)
          }
        },
        share (pType) {
          var pUrl = window.location.href; //当前的url地址
          this.shareys(pType, pUrl);
        },
        //以下shareys是主要的分享的api接口
        shareys (type, url) {
          const title = '智慧农业Erp官网'
          switch (type) {
            case "sina":
              url = "http://service.weibo.com/share/share.php?title=" + encodeURIComponent('「' + title + '」' + ' 点这里' + url);
              window.open(url);
              break;
            case "tqq":
              url = "http://share.v.t.qq.com/index.php?c=share&a=index&url=" + encodeURIComponent(url) + '&title=' + encodeURIComponent(title);
              window.open(url);
              break;
            case "qzone":
              url = 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title);
              window.open(url);
              break;
            default:
              break;
          }
        },
        //分享到微信朋友圈
        share_wx(){
          var el = document.getElementById('wx_share');
          el.target = '_new';
          el.click();
        }


      }
    }
  </script>
<style lang="scss">
  @import "@/styles/app/common/index.scss";
</style>
<style lang="scss" scoped>
  @import "@/styles/app/carousel/index.scss";
  @import "@/styles/app/index/index.scss";
</style>



// WEBPACK FOOTER //
// src/views/app/index.vue